export default __webpack_public_path__ + "static/media/1602.2551c9d4.png";